import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home',            to: '/'               },
  { label: 'About',           to: '/about'          },
  { label: 'Brands',          to: '/brands'         },
  { label: 'Operating Model', to: '/operating-model'},
  { label: 'Contact',         to: '/contact'        },
];

export default function Header() {
  const [scrolled,   setScrolled]   = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setMobileOpen(false); }, [location]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <>
      <header className={`header ${scrolled ? 'header--solid' : 'header--transparent'}`}>
        <div className="header__inner">

          <Link to="/" className="header__logo-link" aria-label="Driven 2 LLC — Home">
            <img
              src="/images/driven2-logo.png"
              alt="Driven 2 LLC — Delivering Results"
              className="header__logo-img"
            />
          </Link>

          <nav className="header__nav" aria-label="Primary navigation">
            {NAV_LINKS.map(({ label, to }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/'}
                className={({ isActive }) => `header__nav-link${isActive ? ' active' : ''}`}
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <Link to="/contact" className="header__cta-btn hide-mobile">Inquire</Link>

          <button
            className={`header__burger${mobileOpen ? ' open' : ''}`}
            onClick={() => setMobileOpen(v => !v)}
            aria-expanded={mobileOpen}
            aria-label="Toggle navigation menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </header>

      <nav
        className={`mobile-menu${mobileOpen ? ' is-open' : ''}`}
        aria-label="Mobile navigation"
        aria-hidden={!mobileOpen}
      >
        <div className="mobile-menu__header">
          <Link to="/" onClick={() => setMobileOpen(false)}>
            <img src="/images/driven2-logo.png" alt="Driven 2 LLC" style={{ height: '44px', width: 'auto' }} />
          </Link>
          <button className="mobile-menu__close" onClick={() => setMobileOpen(false)} aria-label="Close menu">✕</button>
        </div>

        <div className="mobile-menu__nav">
          {NAV_LINKS.map(({ label, to }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={() => setMobileOpen(false)}
            >
              {label}
            </NavLink>
          ))}
        </div>

        <div className="mobile-menu__footer">
          <div className="mobile-menu__contact">
            <div>
              <a href="tel:9046387199">904-638-7199</a>{' · '}
              <a href="mailto:info@driven2.net">info@driven2.net</a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
